import React, { useState, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import Box from '../../hoc/Box/Box';
import  classes from './WifiSecurity.css';
import SelectDropdown from '../../shared/SelectDropdown/SelectDropdown';
import * as actions from '../../store/actions/index';
import Modal from '../../components/UI/Modal/Modal';
import Error from '../../components/UI/Error/Error';
import Success from '../../components/UI/Success/Success';
import Confirm from "../../components/UI/Confirm/Confirm";
import { FaInfoCircle } from 'react-icons/fa';
import { useSelector } from 'react-redux';


const WifiSecurity = (props) => {
  const [bands, setBands] = useState([]);
  const [securityOptions, setSecurityOptions] = useState([]);
  const [collapseState, setCollapaseState] = useState(false);
  const [selectedBandIndex, setSelectedBandIndex] = useState(undefined)
  const [confirmModal, setConfirmModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const wifiSecurityFail = useSelector(state => state.wifiSecurity.wifiSecurityFail)
  const wifiSecurityLoading = useSelector(state => state.wifiSecurity.wifiSecurityLoading)
  const wifiSecurityDetails = useSelector(state => state.wifiSecurity.wifiSecurity)


  const handleSecurityChange = (index, event) => {
    const updateBands = [...bands];
    updateBands[index].options.map(option => {
      if(option.value === event.value){
        option.selected = true;
      }else{
        option.selected = false;
      }
    })
    setBands(updateBands);
  }

  useEffect(()=> {
    props.getAllWifiSecuritySummary();
  },[]);

  useEffect(() => {
    if(!!props.wifiSecurity){
      formatWifiSecurityValues();
    }
  }, [props.wifiSecurity]);

  const formatWifiSecurityValues = () => {
    let securityDetails = [];
    let options = [];
    const getFrequency = (securityId) => {
      if(securityId.includes('24GHZ')){
        return '2.4 GHz'
      }else if(securityId.includes('5GHZ')){
        return '5 GHz'
      }else if(securityId.includes('6GHZ')){
        return '6 GHz'
      }
    }
    Object.entries(props.wifiSecurity?.wifiSecurity)?.map((securityInfo) => {
      //  console.log("Testing Map error",securityInfo)
      if(securityInfo[0].includes('PRIMARY')){
        options = securityInfo[1]?.userSelectableOptions && securityInfo[1]?.userSelectableOptions.map(option => {
          return {
            label: option,
            value: option,
            selected: securityInfo[1].userSelectedValue === option
          }
        });
        securityDetails.push({
          frequency: getFrequency(securityInfo[0]),
          security: securityInfo[1].value,
          securityId: securityInfo[0],
          options: options,
          userSelectedValueAllowed: securityInfo[1].userSelectedValueAllowed
        });
      }
    })
    setBands(securityDetails);
  }

  const confirmModalConfirmHandler = () => {
    if(selectedBandIndex !== undefined){
      const payload = {
        settingId: bands[selectedBandIndex].securityId,
        security:bands[selectedBandIndex].options.filter(option => option.selected)[0]['value']
      }
      props.onWifiSecurityBandSave({ ...payload, setShowSuccessModal, setShowErrorModal });
    } else {
      bands.map((band, index) => {
        let securityValue = bands[index].options.filter(option => option.selected)[0]['value'];
        const payload = {
          settingId: bands[index].securityId,
          security: securityValue === 'WPA2' ? 'WPA3T' : 'WPA2'
        }
        props.onWifiSecurityBandSave({ ...payload, setShowSuccessModal, setShowErrorModal });
      })

      setBands(prev => prev.map((p, index) => ({ ...p, secuirty: bands[index].secuirty })));

    }
    closeModal();
  }
  const confirmModalCancelHandler = () => {
    setConfirmModal(false);
    setSelectedBandIndex(undefined);
  }
  const closeModal= () => {
    setConfirmModal(false);
    setSelectedBandIndex(undefined);
  }

  const securityProtocolConfirmationModal = useMemo(() =>  {
    let bandText =  'all the bands';
    if(selectedBandIndex !== undefined){
      bandText = bands[selectedBandIndex]?.frequency;
    }
    return (
      <>
        <Modal
          show={confirmModal}
          modalClosed={closeModal}
          cancel={closeModal}
          customStyle={{
            width: "30%",
            transform: `translate(${window.innerWidth > 600 ? '-125px' : '0px'}, 148px)`,
            border: "none",
            borderRadius: "8px",
            zIndex: 1000
          }}
        >
          <div style={{ display: "flex", alignItems: "center", margin:'5px' }}>
            <span>
              <FaInfoCircle
                color='#38a9f9'
                size={24}
                style={{ display: "flex", marginRight: "10px", marginLeft: "5px" }}
              />
            </span>
            <h3>Security Protocol Change</h3>
            <span id = 'X' onClick={closeModal} style={{ position: 'absolute',right: '15px',  color: '#555555', cursor: 'pointer' }}>X</span>

          </div>
          <div id='SecurityProtocolWarning' style={{ margin: '5px'}}>{ `You’re about to change the security protocol for ${bandText}, connected devices might be interrupted. Do you want to proceed?.`} <br /></div>

            <Confirm
                id={"securityProtocolChangeConfirm"}
                confirm={confirmModalConfirmHandler}
                confirmButtonLabel='Ok'
                cancel={confirmModalCancelHandler}
                deviceGroupConfirmation={true}
                hideContent={true}
                footerStyle={classes.footerStyle}
            />
        </Modal>
      </>
    )
  },[confirmModal]);

  let collapseArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    if (collapseState) {
      collapseArrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
    } else {
      collapseArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
    }

    let ChangeAllBtn = (
        <div className={classes.TitleArea}>
          <button
            className={classes.ActionButton}
            id="ChangeAllButton"
            onClick={() => setConfirmModal(true) }
          >
            Change All
          </button>
        </div>
      );



  let wifiSecurityTableData = bands.map((band, index) => {
    return (
      <div
        className={classes.TableInfoRow}
        style={{ borderRadius: '0px 0px 5px 5px' }}
        key={index}
      >
        <div
          id="BandFrequency"
          className={classes.TableValueFirst}
          style={{ paddingLeft: '15px', display:'flex', flexDirection:'row'  }}
        >{band.frequency}
        </div>
        <div
          id="BandSecurity"
          className={classes.TableValueAreaSmall}
          style={{ paddingLeft: '0px', marginRight: '45px', wordBreak:'break-word' }}
        >
          <SelectDropdown
            id='BandSecuritySelect'
            className={classes.TimeSelector}
            defaultValue={band.options?.filter(option => option.selected)[0]}
            onChange={(e)=>handleSecurityChange(index, e)}
            options= {band.options}
          />
        </div>
        <div
          id="SaveBand"
          className={classes.TableValueAreaBig}
          style={{ paddingLeft: '0px', marginRight: '10px' }}
        >
          <button
            className={classes.SaveActionButton}
            id="SaveBandButton"
            onClick={() => {
              setSelectedBandIndex(index);
              setConfirmModal(true);
            }}
            disabled={!band.userSelectedValueAllowed}
          >
            Save
          </button>
        </div>
      </div>
    );
  });

let wifiSecurityTable = (
    <div className={classes.InfoRow}>
      <div className={[classes.WifiSecurityTable].join(' ')} style={{overflowY: 'scroll' }}>
        <div
          className={classes.TableHeaderRow}
          style={{ borderRadius: '10px 10px 5px 5px' }}
        >
          <div
            className={classes.HeaderFirst}
            style={{ paddingLeft: '8px' }}
          >
            Radio
          </div>
          <div
            className={classes.HeaderAreaSmall}
            style={{ paddingLeft: '0px', marginRight: '40px' }}
          >
            Security Protocol
          </div>
          <div
            className={classes.HeaderAreaBig}
          >
            {ChangeAllBtn}
          </div>

        </div>
        {wifiSecurityTableData}

        <div
          className={classes.TableEndRow}
          style={{ borderRadius: '0px 0px 5px 5px' }}
        ></div>
      </div>
    </div>
);

  return (
    <div className={classes.wifiSecurityContainer}>
      <Collapsible
        transitionTime={100}
        open={collapseState}
        onOpening={() => setCollapaseState(true)}
        onClosing={() => setCollapaseState(false)}
        trigger={
          <Box>
            <div className={classes.wifiSecurityCollapse}>
              <div className={classes.TitleAreaSection}>
                <h3 style={{ paddingRight: 20, cursor: 'pointer' }}>
                  Wifi Security
                </h3>
                <button
                  id="wifiSecurityArrow"
                  className={classes.OpenCloseButton}
                  style={{ float: 'right' }}
                  aria-label="open arrow"
                >
                  {collapseArrow}
                </button>
              </div>
              <div className={classes.wifiStatus}>
                {bands.map((band, index) => (
                  <span key={index}>
                    {band.frequency}: {band.security}
                    {index < bands.length - 1 && ' | '}
                  </span>
                ))}
              </div>
              <div className={classes.HorizontalSeparator} />
            </div>
          </Box>
        }
      >
        {wifiSecurityTable}
      </Collapsible>
      {securityProtocolConfirmationModal}
      <Modal
        show={showErrorModal}
        modalClosed={() => setShowErrorModal(false)}
        showCloseIcon
        customStyle={{
          border: "none",
          borderRadius: "8px",
          zIndex: 1000
        }}
      >
        <Error showOldView />
      </Modal>
      <Modal
        show={showSuccessModal}
        modalClosed={() => setShowSuccessModal(false)}
        showCloseIcon
        customStyle={{
          border: "none",
          borderRadius: "8px",
          zIndex: 1000
        }}
      >
        <Success showIcon subHeading="Action has been completed" />
      </Modal>
    </div>
  );

}
const mapStateToProps = (state) => ({
  wifiSecurity: state.wifiSecurity,
  wifiSecurityLoading: state.wifiSecurity.wifiSecurityLoading,
  wifiSecuritySuccess: state.wifiSecurity.wifiSecuritySuccess,
  wifiSecurityFail: state.wifiSecurity.wifiSecurityFail
});

const mapDispatchToProps = (dispatch) => ({
  onWifiSecurityBandSave: (payload) => {
    dispatch(actions.setWifiSecurityBand(payload));
  },
  getAllWifiSecuritySummary: () => {
    dispatch(actions.getAllWifiSecuritySummary());
},
});



export default connect(mapStateToProps, mapDispatchToProps)(WifiSecurity);